import * as React from 'react';

const LeftButton: React.FC = () => {
    return (
		<svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="11" height="9.626"><path fill="#1B43F5" d="M10.313 4.126H2.159l2.496-2.998a.688.688 0 10-1.059-.88L.158 4.373a.84.84 0 00-.062.104c0 .034 0 .055-.048.089A.7.7 0 000 4.813a.691.691 0 00.048.247c0 .034 0 .055.048.089.018.036.039.07.062.103l3.438 4.125a.692.692 0 00.969.09.686.686 0 00.09-.967l-.001-.001-2.495-2.998h8.154a.687.687 0 000-1.375z"/></svg>
	);
};

export default React.memo(LeftButton);
